<template>
  <b-container>
    <indica-form
      :show-extra-sections="false"
      :show-many="false"
      :table-name="tableName"
      @refresh="increaseRefresh"
      :label-prefix="table.labelPrefix"
    />
    <indica-list
      :refresh="refresh"
      :table-name="tableName"
      @onRowClick="onRowClick"
    />
  </b-container>
</template>
<script>
import IndicaList from "./indica-list";
import { GetTableDataByName } from "./tablesConfiguration";
import IndicaForm from "./indica-form";
export default {
  name: "IndicaListFromUrl",
  components: { IndicaForm, IndicaList },
  data() {
    return {
      tableName: "",
      refresh: 0,
      table:null
    };
  },
  watch: {
    $route() {
      this.tableName = this.$route.meta.tableName;
      this.getTable()
    },
  },
  created() {
    this.tableName = this.$route.meta.tableName;
    this.getTable()
  },
  methods: {
    getTable(){
      this.table = GetTableDataByName(this.tableName);
    },
    increaseRefresh() {
      this.refresh++;
    },
    onRowClick(record) {
      const table = GetTableDataByName(this.tableName);
      const id = record[table.idName];
      this.$router.push(`/configuration/${this.tableName}/view/${id}`);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
